import { ValidHeimspielResultProps } from './types'

const isValidHeimspielResultProps = (
  props: any
): props is ValidHeimspielResultProps => !!props?.matchId

export { isValidHeimspielResultProps }
